import { Link } from 'react-router-dom';
import { aboutImages } from '@/mocks/manga';

export default function AboutTeaser() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-label="关于073漫画网">
      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
        <div className="relative order-2 lg:order-1">
          <img
            src={aboutImages.gym}
            alt="073漫画网品牌介绍"
            title="073漫画网品牌介绍"
            className="h-64 w-full rounded-lg object-cover object-top md:h-80"
          />
          <img
            src={aboutImages.team}
            alt="073漫画网团队"
            title="073漫画网团队"
            className="absolute -bottom-6 left-4 hidden w-48 rounded-lg border-4 border-background-50 object-cover object-top shadow-none sm:block md:w-60"
          />
        </div>

        <div className="order-1 lg:order-2">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
            About Us
          </span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">
            关于073漫画网，我们只做一件事——让你看得爽
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            073漫画网是一个专注健身题材与热血都市漫画的免费阅读平台。从《健身教练》起步，我们坚持"优质内容 + 流畅阅读 + 每日更新"，让每一位读者都能零门槛感受漫画的魅力。
          </p>
          <ul className="mt-6 space-y-3">
            {[
              { icon: 'ri-book-open-line', text: '全站漫画免费阅读，下拉式流畅体验' },
              { icon: 'ri-refresh-line', text: '每日稳定更新，第一时间追更最新章节' },
              { icon: 'ri-heart-3-line', text: '读者口碑第一，编辑精选每一部作品' },
            ].map((item) => (
              <li key={item.icon} className="flex items-center gap-3 text-sm text-foreground-800">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={item.icon} aria-hidden="true" />
                </span>
                {item.text}
              </li>
            ))}
          </ul>
          <Link
            to="/about"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            了解更多
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}